import { useBillingScheduleAggregate } from 'BillingScheduleHome/utils/useBillingScheduleAggregate'
import { getScheduleDates } from '@sequencehq/utils'

export const useScheduleDates = (props: { billingScheduleId: string }) => {
  const billingScheduleAggregateQuery = useBillingScheduleAggregate({
    billingScheduleId: props.billingScheduleId,
    select: data => {
      const scheduleDates = getScheduleDates({
        startDate: data.billingSchedule.startDate,
        endDate: data.billingSchedule.endDate,
        recurrenceDayOfMonth: data.billingSchedule.recurrenceDayOfMonth,
        phases: data.billingSchedule.phases,
        prices: data.prices
      })

      return {
        nextBillingDate: scheduleDates.nextBillingDate,
        phaseRecurrenceDates: data.billingSchedule.phases.map(
          (phase, index) => ({
            id: phase.id,
            recurrenceDayOfMonth:
              scheduleDates.phaseRecurrenceDates[index]?.recurrenceDayOfMonth
          })
        ),
        startDate: data.billingSchedule.startDate,
        endDate: data.billingSchedule.endDate,
        currentPhaseStartDate: scheduleDates.currentPhaseStartDate
      }
    }
  })

  return {
    isLoading: billingScheduleAggregateQuery.isPending,
    nextBillingDate: billingScheduleAggregateQuery.data?.nextBillingDate,
    startDate: billingScheduleAggregateQuery.data?.startDate,
    endDate: billingScheduleAggregateQuery.data?.endDate,
    currentPhaseStartDate:
      billingScheduleAggregateQuery.data?.currentPhaseStartDate,
    phaseRecurrenceDates:
      billingScheduleAggregateQuery.data?.phaseRecurrenceDates
  }
}
